import React, { useEffect, useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { Avatar, Skeleton } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import lodash from 'lodash';
import { getGroupRequest, showCreateGroupModal } from '../../actionCreators/groupActions';
import ImageApi from '../../api/image';
import { Portal } from '../index';
import CrossIcon from '../Icons/CrossIcon';
import GroupPlaceholder from '../../assets/images/group_placeholder.svg';
import { logFirebaseEvent } from '../../firebase/analytics';
import { goBack } from 'connected-react-router';

const BACK_TEXT = {
  '/': 'Back to organization feed',
  '/search': 'Back to Search',
};

const FeedGroupHeaderComponent = (props) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    imageUrl: '',
    showConfirmLeave: false,
    showCantLeave: false,
    showLastModerator: false,
  });

  useEffect(() => {
    if (props.group && props.group.image && props.group.image.url) {
      getImage(props.group.image.url);
    }
    logFirebaseEvent({
      event: 'group',
      action: 'feed',
    });

    if (props.group && props.group.image && props.group.image.url) {
      getImage(props.group.image.url);
    }
  }, []);

  const renderContent = () => {
    const { group, categories, prevRoute } = props;

    if (!group) return <Skeleton className="feed-group-header-skeleton" />;

    const category = lodash.find(categories, { id: group.category_id }) || {};

    return (
      <>
        <div className="feed-group-header-back-link" onClick={() => navigate(-1)}>
          <FontAwesomeIcon
            icon={['fas', 'chevron-left']}
            className="feed-group-header-back-link-icon"
          />
          {BACK_TEXT[prevRoute] || 'Go back'}
        </div>

        <div className="d-flex align-items-center mb-2">
          {state.imageUrl ? (
            <Avatar
              shape="square"
              className="feed-group-header-image"
              src={state.imageUrl}
              size={100}
            />
          ) : (
            <div className="feed-group-header-image feed-group-header-image__default">
              <img src={GroupPlaceholder} width="80" alt="" />
            </div>
          )}

          <div className="d-flex justify-content-end flex-wrap flex-fill">
            <div className="d-flex flex-column flex-fill">
              <span className="feed-group-header-title">{group.name}</span>

              <div className="d-flex flex-wrap align-items-center">
                {!group.is_org_level && category.category_name && (
                  <>
                    <span className="feed-group-header-category">{category.category_name}</span>
                    <span className="feed-item-footer-splitter grey" />
                  </>
                )}

                <Link
                  to={{ search: '?listType=group&showUsers=true' }}
                  className="feed-group-header-amount"
                >
                  {group.total_users} member{group.total_users > 1 ? 's' : ''}
                </Link>
              </div>
            </div>
            {group.is_requested ? (
              <div className="feed-group-header-buttons-container">
                <div className={`feed-group-header-button disabled-b`}>{'Request sent'}</div>
              </div>
            ) : (
              <div className="feed-group-header-buttons-container">
                {!group.is_mandatory && !group.is_org_level && (
                  <div
                    className={`feed-group-header-button ${
                      group.is_mandatory || (group.is_join && group.is_org_level) ? 'disabled-b' : ''
                    }`}
                    onClick={!group.is_mandatory ? _onToggleJoinClick : null}
                  >
                    {group.is_join ? 'Leave group' : 'Join group'}
                  </div>
                )}
 
                {group.is_moderator && (
                  <NavLink
                    key={`/manage-group/${group.id}`}
                    to={`/manage-group/${group.id}`}
                    className={`feed-group-header-button`}
                  >
                    {'Manage group'}
                  </NavLink>
                )}
              </div>
            )}
          </div>
        </div>
        <span className="feed-group-header-desc">{group.description}</span>
      </>
    );
  };

  const getImage = (imageUrl) => {
    ImageApi.getImage(imageUrl).then((imageUrl) => {
      setState({ imageUrl: imageUrl });
    });
  };

  const _onToggleJoinClick = () => {
    if (props.group.is_join && props.group.is_moderator && props.group.moderator_count == 1) {
      return setState({ showLastModerator: true });
    }
    if (props.group.is_join && props.group.is_org_level) return setState({ showCantLeave: true });
    if (props.group.is_join) return setState({ showConfirmLeave: true });

    _toggleJoinGroup();
  };

  const _toggleJoinGroup = () => {
    logFirebaseEvent({
      event: 'group',
      action: !props.group.is_join ? 'Join' : 'leave',
    });
    props.toggleJoinGroup({ groupId: props.group.id, join: !props.group.is_join });
    _closeModal();
  };

  const _closeModal = () => {
    setState({ showConfirmLeave: false, showCantLeave: false, showLastModerator: false });
  };

  const { group } = props;
  return (
    <>
      <div className="feed-group-header">
        <div className="feed-group-header-content">{renderContent()}</div>

        <Portal hide={_closeModal} isOpen={state.showConfirmLeave}>
          <div className="modal-content">
            <div className="modal-header bg-white">
              <h5 className="modal-title text-center w-100">Are you sure?</h5>

              <div className="close" onClick={_closeModal}>
                <CrossIcon className="modal-close" />
              </div>
            </div>

            <div className="feed-group-header-modal-body">
              <div className="feed-group-header-modal-button" onClick={_toggleJoinGroup}>
                Yes
              </div>
              <div className="feed-group-header-modal-button" onClick={_closeModal}>
                No
              </div>
            </div>
          </div>
        </Portal>

        <Portal hide={_closeModal} isOpen={state.showCantLeave} minWidth="400px">
          <div className="modal-content">
            <div className="modal-header bg-white">
              <div className="d-flex flex-column align-items-center w-100">
                <h5 className="modal-title text-center w-100">Sorry</h5>
                <h6 className="modal-sub-title text-center w-100">
                  You can't leave organization level group
                </h6>
              </div>

              <div className="close" onClick={_closeModal}>
                <CrossIcon className="modal-close" />
              </div>
            </div>

            <div className="feed-group-header-modal-body justify-content-center">
              <div className="feed-group-header-modal-button" onClick={_closeModal}>
                Okay
              </div>
            </div>
          </div>
        </Portal>

        <Portal hide={_closeModal} isOpen={state.showLastModerator} minWidth="400px">
          <div className="modal-content">
            <div className="modal-header bg-white">
              <div className="d-flex flex-column align-items-center w-100">
                <h5 className="modal-title text-center w-100">Sorry</h5>
                <h6 className="modal-sub-title text-center w-100">
                  A group must have at least one moderator. You cannot leave before assigning
                  another moderator.
                </h6>
              </div>

              <div className="close" onClick={_closeModal}>
                <CrossIcon className="modal-close" />
              </div>
            </div>

            <div className="feed-group-header-modal-body justify-content-center">
              <div className="feed-group-header-modal-button" onClick={_closeModal}>
                Okay
              </div>
            </div>
          </div>
        </Portal>
      </div>
    </>
  );
};

const FeedGroupHeader = (props) => {
  const state = useSelector((state) => ({
    categories: state.categories,
    groupDetails: state.group.getGroupRequest,
    prevRoute: state.routerHistory.prevPathname,
    showNewGroupModal: state.group.showCreateGroupModal,
  }));

  const dispatch = useDispatch();

  const actions = {
    groupDetails: payload => dispatch(getGroupRequest(payload)),
    showCreateGroupModal: (payload) => dispatch(showCreateGroupModal(payload)),
  };

  return <FeedGroupHeaderComponent {...props} {...state} {...actions} />;
};

export default FeedGroupHeader;
